import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import SVGInline from "react-svg-inline"

import lightningSvg from '../../inlineSVGs/lightningSVG';

import '../stylesModal.css';
import './navigation.css';
import navMugicsSVG from './images/navMugicsSVG';
import {clientMedia} from "../../../Config/Settings";

const NavigationMobile = ({ closeModal, isModalOpen, onSelectNav }) => {
    return (
        <Modal
            isOpen={isModalOpen}
            contentLabel="Modal"
            className="modal-wrapper navigation-mobile-modal rtl"
            style={{overlay: {
                    backgroundColor: 'rgba(0, 0, 0, 0)'
                }}}
        >
            <div className="close-button" onClick={closeModal}>
                X
            </div>
            <SVGInline component="i" svg={navMugicsSVG} width="45px" className="upper-mugics"/>
            <div className="content-wrapper">
                <span className="title">יוצאים לדרך!</span>
                <SVGInline svg={lightningSvg} component="i" width="30px" fill="#6dc6b0" className="lighting-icon"/>
                <span className="text">בחרו את אפליקציית הניווט המועדפת עליכם</span>
                <img onClick={() => onSelectNav('waze')} className="navigation-options" src={`${clientMedia()}/img/icons/wazeIcon.png`} alt="waze-icon"/>
                <img onClick={() => onSelectNav('googlemaps')} className="navigation-options" src={`${clientMedia()}/img/icons/googlemapsIcon.png`} alt="googlemap-icon"/>
            </div>
        </Modal>
    )
};

NavigationMobile.propTypes = {
    closeModal: PropTypes.func,
    isModalOpen: PropTypes.bool,
    onSelectNav: PropTypes.func
};

export default NavigationMobile;



// WEBPACK FOOTER //
// ./src/Components/Modals/Navigation/NavigationMobile.js